export default __webpack_public_path__ + "static/media/default.a1b9e03452f1fc8542e2a6d109ef88a7.png";